// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getBannerApi } from "../../services/Api/BannerApi"
import { getErrors, getHeroBannerSuccess } from "../reducers/BannerReducer"

// Watchers
function* heroBannerSaga() {
	yield takeEvery("hero_banner/getHeroBanner", getHeroBanners)
}

// Sagas
function* getHeroBanners(action) {
	// console.log(action.payload.name, "saga payload")
	try {
		const getBanners = yield call(getBannerApi, action.payload)
		// console.log(getBanners, "banner saga response")

		if (getBanners) {
			yield put(getHeroBannerSuccess(getBanners))
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {
		// console.log(error,"otp error")
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(heroBannerSaga)])
}
